// Page translators (Chrome, Telegram in-app browser, etc.) replace text nodes rendered by React with their own elements.
// When React later removes or inserts next to such a node, the browser throws NotFoundError and the whole app crashes.
// See https://github.com/facebook/react/issues/11538
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;

  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      console.warn('Cannot remove a child from a different parent', child, this);

      return child;
    }

    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;

  Node.prototype.insertBefore = function <T extends Node>(this: Node, newNode: T, referenceNode: Node | null): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn('Cannot insert before a reference node from a different parent', referenceNode, this);

      return originalInsertBefore.call(this, newNode, null) as T;
    }

    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}

export {};
